// extracted by mini-css-extract-plugin
export default {"SearchBar":"iXddJy0kE6K3paLp0RLrtg==","SubmitButton":"r4Tiyd6qPVoDvvzP912i8Q=="};